function ApplicationRightBar() {
    return (
        <></>
    );
}
export default ApplicationRightBar;
